import React, { useLayoutEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Immutable from 'immutable';

import { connect } from 'react-redux';

import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';

import ModuleList from '../../../layout/ModuleList';

import {
  MANUAL_VOUCHER_PAYMENT_PATH,
  MANUAL_VOUCHER_PAYMENT_RECONCILIATION_PATH,
  NEW_MANUAL_VOUCHER_PAYMENT_PATH,
} from '../../../../config/paths';

import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

import { generateManualVoucherPaymentColumns } from '../../../../config/columns';

import {
  clearManualVoucherPayments,
  getManualVoucherPayments,
} from '../../../../actions/corporate/ManualVoucherPayment';

export const ManualVoucherPayments = ({
  breadcrumbs,
  manualVoucherPayments,
  loading,
  dispatchGetManualVoucherPayments,
  dispatchClearManualVoucherPayments,
}) => {
  const [tableFilters, setTableFilters] = useState(null);

  useLayoutEffect(() => () => dispatchClearManualVoucherPayments(), []);

  const onFetchData = (data) => {
    const newData = {
      ...data,
      query: data.query ? [...data.query] : data.query,
    };

    const businessTaxIdFound =
      newData.query &&
      newData.query.length &&
      newData.query.filter(
        (column) =>
          column.substring(0, column.indexOf(':')) === 'business.businessTaxId',
      );

    if (businessTaxIdFound && businessTaxIdFound[0]) {
      const documentValue = businessTaxIdFound[0].substring(
        businessTaxIdFound[0].indexOf(':') + 1,
      );

      const documentIndex = newData.query.indexOf(businessTaxIdFound[0]);

      const column =
        documentValue.length === 8
          ? 'customer.idDocumentNumber'
          : 'business.businessTaxId';

      newData.query[documentIndex] = `${column}:${documentValue}`;
    }

    setTableFilters(newData);

    dispatchGetManualVoucherPayments(newData);
  };

  const data = manualVoucherPayments.get('content') || [];

  const pages = manualVoucherPayments.get('totalPages') || null;

  const defaultPageSize =
    manualVoucherPayments.get('size') || DEFAULT_PAGE_SIZE;

  const extraButtons = (
    <Button
      color="success"
      tag={Link}
      className="mr-2"
      to={MANUAL_VOUCHER_PAYMENT_RECONCILIATION_PATH}
    >
      <i className="fa fa-exchange" /> Conciliar pagos
    </Button>
  );

  return (
    <ModuleList
      title="Lista de Pagos de Comprobantes Manuales"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_MANUAL_VOUCHER_PAYMENT_PATH}
      extraButtons={extraButtons}
      tableStructure={{
        columns: generateManualVoucherPaymentColumns(tableFilters),
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: onFetchData,
        loading,
        modelPath: MANUAL_VOUCHER_PAYMENT_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetManualVoucherPayments: getManualVoucherPayments,
  dispatchClearManualVoucherPayments: clearManualVoucherPayments,
};

const mapStateToProps = ({ CorporateUnit }) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Pagos de Comprobantes Manuales',
      href: MANUAL_VOUCHER_PAYMENT_PATH,
    },
  ],

  manualVoucherPayments: CorporateUnit.ManualVoucherPayment.getIn([
    'all',
    'content',
  ]),

  loading: CorporateUnit.ManualVoucherPayment.getIn(['all', 'loading']),
});

ManualVoucherPayments.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  manualVoucherPayments: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetManualVoucherPayments: PropTypes.func.isRequired,
  dispatchClearManualVoucherPayments: PropTypes.func.isRequired,
};

ManualVoucherPayments.defaultProps = {
  manualVoucherPayments: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManualVoucherPayments);
